// Utility functions for media handling

/**
 * Checks if a file URL or path is a video based on its file extension
 * @param url - The file URL or path to check
 * @returns true if the file is a video, false otherwise
 */
export function isVideoFile(url: string): boolean {
  if (!url) return false;
  
  const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm', '.m4v', '.3gp', '.flv', '.wmv'];
  const extension = url.split('.').pop()?.toLowerCase();
  
  return extension ? videoExtensions.includes(`.${extension}`) : false;
}

/**
 * Gets the file extension from a URL or path
 * @param url - The file URL or path
 * @returns The file extension (without the dot) or empty string if not found
 */
export function getFileExtension(url: string): string {
  if (!url) return '';
  return url.split('.').pop()?.toLowerCase() || '';
}